import _ from 'lodash'
import { UUID } from '../../plugins/common'
import { relationTypes } from './schema'
import sdk from 'redcatSdk'

// 1. 整合所有属性到此文件中。
// 2. 整理属性项。
const properties = {
  'address': {
    addressRequired: {
      province: false,
      city: false,
      area: false,
      address: false
    }
  },
  'alignment': {
    justifyContent: 'center',
    alignItems: 'flex-start',
    fontWeight: 'normal',
    color: '#000'
  },
  'archived': {
    archived: {
    }
  },
  'archived-table': {
    archivedTable: {
    }
  },
  'currency-type': {
    currencyType: '人民币'
  },
  'setting-option': {
    dataSource: {
      enable: false,
      dataSource: '',
      reportId: '',
      columnId: '',
      showColumnId: '',
      // 数据绑定
      bindData: {
        enable: false,
        dataBinding: [{showColumnId: '', componentId: ''}]
      }
    },
    template: {
      enable: true,
      method: 'static',
      groupId: '1',
      stringOptions: '选项1\n选项2\n选项3'
    }
  },
  'data-source-privide': {
    dataSourceData: {
      dataSource: '',
      showColumnId: '',
      dataBinding: [],
      filter: {},
      filterHide: {}
    }
  },
  'date-type': {
  },
  'setting-value': {
    default: {
      settingEnable: true,
      defaultValue: '',
      secondDefaultValue: '',
      enable: false
    },
    calculate: {
      enable: false,
      calculationPanelData: {
        expression: '',
        secondExpression: ''
      },
      realTime: false
    },
    related: {
      enable: false,
      tableId: '',
      relComponent: '',
      srcLocation: '',
      relField: '',
      srcField: '',
      secondRelComponent: '',
      secondSrcLocation: '',
      secondRelField: '',
      secondSrcField: ''
    }
  },
  'discern': {
    discriminate: {
      recognizeAddr: '',
      recognizeSex: '',
      recognizeBirthday: '',
      recognizeAge: ''
    }
  },
  'height': {
    height: ''
  },
  'hidden': {
    hidden: false,
    seat: false
  },
  'limit': {
    limit: {
      enable: false,
      // 触发方式是否为blur默认为false
      triggerBlur: false,
      rules: []
    }
  },
  'max-row-module': {
    numberOfColumns: 4,
    numberOfLines: 4,
    maxNum: 5,
    enableEdit: false,
    selectForm: '[默认表单]',
    selectProperties: ''
  },
  'name': {
    name: ''
  },
  'placeholder': {
    placeholder: '',
    endTimeplaceholder: ''
  },
  'postfix': {
    numType: 'num',
    customSuffix: '',
    decimal: '2'
  },
  'code': {
    code: {
      startNumber: '1',
      length: '3',
      expression: '',
      isPrefix: false,
      isRestart: false
    }
  },
  'readonly': {
    readonly: false
  },
  'relevance': {
    loginUser: {
      jobNum: '',
      department: '',
      post: ''
    }
  },
  'repeatability': {
    repeatability: false
  },
  'required': {
    required: false
  },
  'row-col': {
    numberOfColumns: 4,
    numberOfLines: 2
  },
  'search-choose': {
    multiple: false,
    search: false,
    hoverToVisible: false
  },
  'sizex': {
    sizex: ''
  },
  'sizey': {
    numberOfLines: 2
  },
  'thousand': {
    bit: false
  },
  'time': {
    calTimeType: 'positiveTiming',
    checkTime: 'first',
    time: {
      HH: 0,
      mm: 0,
      ss: 0
    }
  },
  'tree': {
    tree: {
      // 手风琴
      accordion: false,
      // 是否筛选
      filter: false,
      // 筛选条件
      filterText: '',
      // 关联控件
      isRelComponents: [{ archivedId: '' }],
      // 树节点控件
      treeName: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // 结构
      structure: [
        {
          id: UUID.create(),
          label: '一级 1',
          children: [
            {
              id: UUID.create(),
              label: '二级 1'
            }, {
              id: UUID.create(),
              label: '二级 2'
            }, {
              id: UUID.create(),
              label: '二级 3'
            }
          ]
        }
      ],
      // 数据
      data: []
    }
  },
  'trigger-mode': {
    openModel: 'dialog',
    link: { dataSource: 'outside', external: 'https://', reportCategory: '', reportId: '' }
  },
  'unfold': {
    organ: {
      childId: '',
      show: true
    }
  },
  'upload': {
    multiple: true,
    drag: false,
    listType: '',
    fileSize: 50,
    allowFileType: []
  },
  'label-content': {
    value: ''
  },
  'ocr': {
    ocr: {
      type: 'text',
      rules: {}
    }
  },
  'disable-copy': {
    disableCopy: false
  },
  'disable-paste': {
    disablePaste: false
  },
  'describe-message': {
    message: {
      oneMessage: '',
      twoMessage: '',
      threeMessage: '',
      fourMessage: '',
      fiveMessage: ''
    }
  },
  'isOpen': {
    isOpen: true
  },
  'add-options': {
    addOptions: false
  },
  'big-file-upload': {
    requestUrl: ''
  },
  'layout': {
    // 双列布局类型 d1: 1：1，d2: 1：3， d3: 3：1；
    // 三列布局类型 t1: 1：1：1, t2: 1：2：1, t3: 1：1：2, t4: 2：1：1
    layoutRatioType: ''
  },
  'report': {
    report: {
      sourceTableId: '',
      filters: null,
      defaultRows: 4
    }
  },
  'js-actions': {
    jsActions: []
  },
  // 富文本框自适应高度，之前未在这里注册
  'height-adaptation': {
    heightAdaptation: false
  },
  // 表格的数据绑定
  'table-data-source': {
    tableDataSource: {
      defaultData: false,
      dataSource: '',
      filter: {},
      dataBinding: []
    }
  },
  // 图片展示控件
  'image': {
    slideModel: true,
    imageList: []
  },
  // 分组控件折叠
  'fold': {
    defaultFold: false
  },
  // 表格锁定行数
  'lock-row': {
    lockRow: false
  },
  // 时间区间可选日期
  'select-data': {
    selectData: {
      startData: '',
      endData: ''
    }
  },
  // 文本类控件宽度
  'input-width': {
    inputWidth: ''
  },
  // 级联下拉-设置选项
  'setting-cascader': {
    settingCascader: {
      // 归档文本
      dataSourceReportId: '',
      bindData: {
        enable: false,
        dataBinding: [{showColumnId: '', componentId: ''}]
      },
      cascaderOptions: [
        {optionId: '', optionShowId: ''},
        {optionId: '', optionShowId: ''}
      ]
    }
  },
  // 数字步幅
  'stride': {
    stride: {
      enable: false,
      number: null
    }
  },
  // 超链接区别新老设计的flag
  'new-design': {
    newDesign: false
  }
}
const componentProperties = {
  'rc-form': {
    // 创建组件时使用的构造函数
    ctor: 'TableComponent',
    // 组建可使用的属性设置
    props: [],
    // 属性默认值
    defaults: {
      name: '表单',
      componentType: 'rc-form',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      formValidates: [],
      interactions: [],
      formNotices: [],
      properties: {formScreen: 'full', continueCreate: false, functionsName: [], groupNav: false},
      pinyinName: '',
      pinyinFirstChar: ''

    }
  },
  'rc-process': {
    ctor: 'ProcessComponent',
    props: [],
    defaults: {
      name: '流程',
      componentType: 'rc-process',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {formScreen: 'full', functionsName: []},
      pinyinName: '',
      pinyinFirstChar: ''

    }
  },
  'rc-input': {
    ctor: 'ColumnComponent',
    props: ['name', 'required', 'archived', 'hidden', 'readonly', 'placeholder', 'limit', 'setting-value', 'disable-copy', 'disable-paste', 'input-width', 'js-actions'],
    defaults: {
      name: '文本',
      componentType: 'rc-input',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-children-input': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'limit'],
    defaults: {
      name: '子控件',
      componentType: 'rc-children-input',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {
        noDelete: true,
        noCollect: true
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-combobox': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'setting-option', 'setting-value', 'search-choose', 'disable-copy', 'disable-paste', 'add-options', 'input-width', 'js-actions'],
    defaults: {
      name: '下拉',
      componentType: 'rc-combobox',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {
        archived: {showColumnId: ''},
        placeholder: '请选择'
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-cascader': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'input-width', 'setting-cascader'],
    defaults: {
      name: '级联下拉',
      componentType: 'rc-cascader',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {
        archived: {showColumnId: ''},
        placeholder: '请选择'
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-date': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'date-type', 'setting-value', 'disable-copy', 'disable-paste', 'input-width', 'js-actions'],
    defaults: {
      name: '日期',
      componentType: 'rc-date',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'date'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-numeric': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'limit', 'postfix', 'setting-value', 'thousand', 'disable-copy', 'disable-paste', 'input-width', 'js-actions', 'stride'],
    defaults: {
      name: '数字',
      componentType: 'rc-numeric',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'decimal0'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-textarea': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'height', 'limit', 'setting-value', 'disable-copy', 'disable-paste', 'input-width', 'js-actions'],
    defaults: {
      name: '多行文本',
      componentType: 'rc-textarea',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'text'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 4,
      'h': 2
    }
  },
  'rc-table': {
    ctor: 'TableComponent',
    props: ['name', 'hidden', 'archived-table', 'max-row-module', 'readonly', 'lock-row', 'disable-copy', 'disable-paste', 'table-data-source'],
    defaults: {
      name: '表格',
      componentType: 'rc-table',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar',
        relationType: relationTypes.ONE2MANY
      },
      properties: {
        widths: []
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 4,
      'h': 3
    }
  },
  'rc-rich-box': {
    ctor: 'ColumnComponent',
    props: ['name', 'hidden', 'heightAdaptation', 'height', 'archived', 'disable-copy', 'disable-paste', 'input-width', 'js-actions'],
    defaults: {
      name: '富文本',
      componentType: 'rc-rich-box',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'html'
      },
      properties: {
        height: 200
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 4,
      'h': 2
    }
  },
  'rc-coding': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'hidden', 'code', 'disable-copy', 'input-width', 'js-actions'],
    defaults: {
      name: '编码',
      componentType: 'rc-coding',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-flowing-water': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'hidden', 'code', 'disable-copy', 'disable-paste', 'input-width', 'js-actions'],
    defaults: {
      name: '流水',
      componentType: 'rc-flowing-water',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-label': {
    ctor: 'ColumnComponent',
    props: ['name', 'label-content', 'hidden', 'height', 'disable-copy', 'input-width', 'js-actions'],
    defaults: {
      name: '描述文字',
      componentType: 'rc-label',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        labelContent: ''
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-button': {
    ctor: 'ColumnComponent',
    props: ['name', 'alignment', 'js-actions'],
    defaults: {
      name: '按钮',
      componentType: 'rc-button',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-currency': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'setting-value', 'postfix', 'currency-type', 'thousand', 'disable-copy', 'disable-paste', 'input-width', 'js-actions'],
    defaults: {
      name: '货币框',
      componentType: 'rc-currency',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'decimal0'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-radio': {
    ctor: 'ColumnComponent',
    props: ['name', 'height', 'required', 'archived', 'hidden', 'readonly', 'setting-option', 'setting-value', 'disable-copy', 'js-actions'],
    defaults: {
      name: '单选',
      componentType: 'rc-radio',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-checkbox': {
    ctor: 'ColumnComponent',
    props: ['name', 'height', 'required', 'archived', 'hidden', 'readonly', 'setting-option', 'setting-value', 'disable-copy', 'js-actions'],
    defaults: {
      name: '复选',
      componentType: 'rc-checkbox',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-upload': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'upload', 'required', 'hidden', 'disable-copy', 'js-actions'],
    defaults: {
      name: '附件',
      componentType: 'rc-upload',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'file'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-big-file-upload': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'bigFileUpload', 'required', 'hidden'],
    defaults: {
      name: '大文件上传',
      componentType: 'rc-big-file-upload',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'file'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-file': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'disable-copy', 'upload', 'js-actions'],
    defaults: {
      name: '附件',
      componentType: 'rc-file',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'file'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-ocr': {
    ctor: 'ColumnComponent',
    props: ['name', 'ocr', 'archived'],
    defaults: {
      name: '文字识别',
      componentType: 'rc-ocr',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'file'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-data-source': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'data-source-privide', 'disable-copy', 'js-actions'],
    defaults: {
      name: '数据源',
      componentType: 'rc-data-source',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-cal-time': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'hidden', 'readonly', 'time', 'disable-copy', 'input-width', 'js-actions'],
    defaults: {
      name: '计时器',
      componentType: 'rc-cal-time',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'decimal'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-content-table': {
    ctor: 'TableComponent',
    props: ['name', 'row-col'],
    defaults: {
      name: '内容表格',
      componentType: 'rc-content-table',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-hyperlink': {
    ctor: 'ColumnComponent',
    props: ['name', 'readonly', 'component-explain', 'required', 'archived', 'disable-copy', 'js-actions', 'new-design'],
    defaults: {
      name: '超链接',
      componentType: 'rc-hyperlink',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-report': {
    ctor: 'ColumnComponent',
    props: ['name', 'report', 'hidden'],
    defaults: {
      name: '报表',
      componentType: 'rc-report',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-image': {
    ctor: 'ColumnComponent',
    props: ['name', 'image'],
    defaults: {
      name: '图片展示',
      componentType: 'rc-image',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'file'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-uuid': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'hidden', 'disable-copy', 'input-width', 'js-actions'],
    defaults: {
      name: '唯一标识',
      componentType: 'rc-uuid',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'identity'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-id-card': {
    ctor: 'ColumnComponent',
    props: ['name', 'required', 'archived', 'hidden', 'readonly', 'setting-value', 'discern', 'disable-copy', 'disable-paste', 'input-width', 'js-actions'],
    defaults: {
      name: '身份证',
      componentType: 'rc-id-card',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {
        limit: { enable: true, rules: [{ 'limitType': '身份证' }] }
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-login-user': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'hidden', 'readonly', 'relevance', 'disable-copy', 'disable-paste', 'input-width', 'js-actions'],
    defaults: {
      name: '登录人',
      componentType: 'rc-login-user',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-phone': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'disable-copy', 'disable-paste', 'input-width', 'js-actions'],
    defaults: {
      name: '手机号',
      componentType: 'rc-phone',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-address': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'hidden', 'address', 'disable-copy', 'disable-paste', 'js-actions'],
    defaults: {
      name: '地址',
      componentType: 'rc-address',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 4,
      'h': 1
    }
  },
  'rc-password': {
    ctor: 'ColumnComponent',
    props: ['name', 'required', 'archived', 'hidden', 'readonly', 'placeholder', 'limit', 'disable-copy', 'disable-paste', 'input-width', 'js-actions'],
    defaults: {
      name: '密码框',
      componentType: 'rc-password',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-group': {
    ctor: 'TableComponent',
    props: ['name', 'fold', 'hidden', 'js-actions'],
    defaults: {
      name: '分组',
      componentType: 'rc-group',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        hidden: false,
        seat: false
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {}
  },
  'rc-multiple-tabs': {
    ctor: 'TableComponent',
    props: ['name', 'readonly', 'js-actions', 'multiple-tabs'],
    defaults: {
      name: '多标签',
      componentType: 'rc-multiple-tabs',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        hidden: false,
        seat: false,
        activeIndex: 0,
        tabCompnents: [[], [], []],
        showLayers: [],
        tabList: ['标签页1', '标签页2', '标签页3']
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {}
  },
  'rc-layout': {
    ctor: 'TableComponent',
    props: ['layout'],
    defaults: {
      name: '布局',
      componentType: 'rc-layout',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {}
  },
  'rc-draggable': {
    ctor: 'TableComponent',
    props: [],
    defaults: {
      name: 'draggable',
      componentType: 'rc-draggable',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {}
  },
  //  成员控件
  'rc-member': {
    // 创建组件时使用的构造函数
    ctor: 'ColumnComponent',
    // 组建可使用的属性设置
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'js-actions'],
    // 属性默认值
    defaults: {
      name: '成员',
      componentType: 'rc-member',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: '',
      position: {
        'w': 1,
        'h': 1
      }
    }
  },
  'rc-rate': {
    ctor: 'ColumnComponent',
    props: ['name', 'required', 'readonly', 'hidden', 'archived', 'describe-message', 'js-actions'],
    defaults: {
      name: '评分',
      componentType: 'rc-rate',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'varchar'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-switch': {
    ctor: 'ColumnComponent',
    props: ['name', 'readonly', 'hidden', 'archived', 'isOpen', 'js-actions'],
    defaults: {
      name: '开关',
      componentType: 'rc-switch',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'enum'
      },
      properties: {},
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  'rc-time-interval': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived', 'required', 'hidden', 'readonly', 'placeholder', 'date-type', 'select-data', 'setting-value', 'disable-copy', 'disable-paste'],
    defaults: {
      name: '时间区间',
      componentType: 'rc-time-interval',
      archive: {
        enable: true,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'date'
      },
      properties: {
        archived: {endColumnId: ''}
      },
      pinyinName: '',
      pinyinFirstChar: ''
    },
    position: {
      'w': 1,
      'h': 1
    }
  },
  /** 下为华奥定制控件 */
  // 固定资产汇总表(只注册了,无实体)
  'cust-fixed-property': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-fixed-property',
      componentType: 'cust-fixed-property',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        rows: [],
        title: '固定资产汇总表'
      }
    }
  },
  'cust-button-export': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: '定制导出按钮',
      componentType: 'cust-button-export',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      }
    }
  },
  // 比价明细
  'cust-priceComparison-table': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-priceComparison-table',
      componentType: 'cust-priceComparison-table',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        rows: [],
        title: '比价明细'
      },
      pinyinName: ''
    }
  },
  // 定制文件上传
  'cust-rc-file': {
    ctor: 'ColumnComponent',
    props: ['name', 'archived'],
    defaults: {
      name: 'cust-rc-file',
      componentType: 'cust-rc-file',
      archive: {
        enable: false,
        defaultId: UUID.create(),
        tableId: undefined,
        columnId: undefined,
        dataType: 'none'
      },
      properties: {
        /* 合作商信息维护流程：
        * 主协议： 16C88D12-DFA0-03C7-8793-DF7821DC1472
        * 补充协议：16C88D53-C9A0-03D7-8595-0DF7E953B20D
        * */
        /* 开店申请：
        * 主协议： 16C88C2D-C660-020E-87EA-6F5DFF31FCFE
        * 补充协议：16C88C63-76C0-021E-CD20-AAB21A5AA187
        * */
        columnId: '16C88D12-DFA0-03C7-8793-DF7821DC1472'
      }
    }
  }
}

function registerSdkComponents () {
  // 合并 sdk 中注册的组件
  if (sdk.componentsDefaults) {
    _.defaults(componentProperties, sdk.componentsDefaults.componentProperties)
    _.defaults(componentProperties, sdk.componentsDefaults.properties)
  }
}

function getProperties (componentType) {
  // todo: 统一处理定制控件， 暂时是每次都手动注册一下
  let component = componentProperties[componentType]
  if (!component) {
    console.error(`请在配置文件 componentDefault.js 中注册 ${componentType} 控件`)
  }
  component.props.forEach(m => {
    if (properties[m]) {
      _.defaults(component.defaults.properties, properties[m])
    }
  })
  return _.cloneDeep(component)
}
export {getProperties, registerSdkComponents}



// WEBPACK FOOTER //
// ./src/store/form/componentDefaults.js